/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from 'react';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import REactJson from 'react-json-view';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

import { LoadSingleUserRequest } from '../../../features/User/UserSlice';
import { loaderActions } from '../../../features/Loader/LoaderSlice';
import { LoadVendorsRequest } from '../../../features/Vendor/VendorSlice';
import { AllCompanyIDs } from '../../../components/shared/Company';
import _ from 'lodash';
import API from '../../../Services/API';
import toast from 'react-hot-toast';

function Search() {
  const dispatch = useDispatch();

  const [email, setEmail] = React.useState('');
  const [userVendors, setUserVendors] = React.useState([]);
  const [user, setUser] = React.useState({});
  const { vendorList } = useSelector((state) => state.vendor);

  const animatedComponents = makeAnimated();

  async function handleSearchUser(e) {
    e.preventDefault();
    dispatch(loaderActions.show());
    const { payload } = await dispatch(LoadSingleUserRequest(email));
    if (payload) {
      if (payload.vendor === null) {
        payload.vendor = [];
      }
      const userVendors = payload.vendor.map((v) => `${v.code}-${v.name}`);
      const vendorsList = vendorList.filter((vendor) => userVendors.includes(vendor.value));
      setUser(payload);
      setUserVendors(vendorsList);
    } else {
      toast.error('User not found.');
    }
    dispatch(loaderActions.hide());
  }

  async function handleSaveUser(e) {
    e.preventDefault();
    dispatch(loaderActions.show());
    await API().patch(`/evp-users/${user.email}`, {
      vendor: user.vendor
    });
    toast.success('User updated successfully.');
    handleSearchUser(e);
    dispatch(loaderActions.hide());
  }

  useEffect(() => {
    async function init() {
      const companyIds = AllCompanyIDs;
      await companyIds.forEach((companyId, idx) =>
        dispatch(
          LoadVendorsRequest({
            type: 'all_vendors',
            companyId
          })
        )
      );
    }
    init();
  }, [dispatch]);

  useEffect(() => {
    if (userVendors.length > 0) {
      const vendors = userVendors.map((v) => {
        return {
          name: v.entity,
          code: v.vendNo
        };
      });
      const uniqueVendors = _.uniqBy(vendors, 'code');

      setUser({ ...user, vendor: uniqueVendors });
    } else {
      setUser({ ...user, vendor: [] });
    }
  }, [userVendors]);

  return (
    <Card className="shadow-none">
      <div className="text-center"></div>
      <Card.Body className="p-4">
        <Card.Title>
          <i className="feather icon-search mt-2" /> &nbsp; Search User
        </Card.Title>
        <Card.Text>Search for a user by email. You can view and edit the user's details.</Card.Text>
        <Form onSubmit={handleSearchUser}>
          <Form.Group controlId="formBasicEmail">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </Form.Group>
          <Button variant="primary" type="submit">
            Search
          </Button>
        </Form>
        {user && user.email && (
          <Container className="mt-4">
            <Row>
              <Col>
                <Form onSubmit={handleSaveUser}>
                  <Form.Group controlId="username">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                      type="username"
                      placeholder="Username"
                      value={user.username}
                      readOnly
                    />
                  </Form.Group>
                  <Form.Group controlId="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Email Address"
                      value={user.email}
                      readOnly
                      onChange={(e) => {
                        setUser({ ...user, email: e.target.value });
                      }}
                    />
                  </Form.Group>
                  <Form.Group controlId="formBasicCheckbox">
                    <Form.Check
                      type="checkbox"
                      checked={user && user.enabled}
                      onChange={(e) => {
                        setUser({ ...user, enabled: Boolean(e.target.checked) });
                      }}
                      label="Status"
                    />
                  </Form.Group>
                  <Form.Group controlId="vendors">
                    <Form.Label>Vendors</Form.Label>
                    <Select
                      isMulti
                      components={animatedComponents}
                      options={vendorList}
                      isSearchable={true}
                      value={userVendors}
                      readOnly
                      onChange={(e) => {
                        setUserVendors(e);
                      }}
                    />
                  </Form.Group>
                  <Button variant="success" type="submit">
                    Save
                  </Button>
                </Form>
              </Col>
              <Col>{user && <REactJson src={user} />}</Col>
            </Row>
          </Container>
        )}
      </Card.Body>
    </Card>
  );
}

export default Search;
